import LivingObject from "../../../../modules/LivingObject"
import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import EventNode, { EventNodeOptions } from "./EventNode"

export type OnDeathEventNodeOptions = {} & EventNodeOptions

export default class OnDeathEventNode extends EventNode {

	static nodeName = "On death node"
	static nodeDesc = "Stalls particles until target death"
	static nodeIcon = '☠'
	static category = NodeCategories.Event
	static nodeType = 'OnDeathEventNode'

	onScroll(dir: number) { }

	bindToEvent(particle: ManaParticle) {
		const target = particle.target

		if (target instanceof LivingObject) {
			return target.onDeath$
		}

		return undefined
	}

}